
init();

function init() {
  // console.log('window.location.pathname: ' + window.location.pathname);
  // すべてのページ
  // すべてのリンククリックをキャッチ
  document.addEventListener('click', function (event) {
    // クリックされた要素が <a> かその子要素かを確認する
    const link = event.target.closest('a');
    // console.log('link.href: ' + link.href);
    // もし link が存在し、<a> タグなら処理を実行
    if (link) {
      link.href = addQueryToUrl(link.href);
      // console.log('link.href.newUrl: ' + link.href);
    }
  });

  // トップページの場合
  // if ((window.location.pathname !== "/" && window.location.pathname !== "") || window.location.hostname.includes('shopify')) return false;
  // redirect2Brand();
}

// トップページへの遷移をすべてキャッチしてクエリを追加
function addQueryToUrl(url) {
  const parsedUrl = new URL(url, window.location.origin);
  // console.log('parsedUrl.pathname: ' + parsedUrl.pathname);
  // コーポレートサイト・ECサイトのいずれか宛てで、かつトップページならクエリを追加
  if (parsedUrl.hostname === 'www.hakusan-porcelain.com' 
    || parsedUrl.hostname === 'www.hakusan-shop-online.com' 
    && (parsedUrl.pathname === '/' || parsedUrl.pathname === '')) {
    parsedUrl.searchParams.set('sd', '1');
    return parsedUrl.toString();
  }
  return url;
}

// ブランドサイトへのリダイレクト
function redirect2Brand() {
  const urlParams = new URLSearchParams(window.location.search);
  // console.log(urlParams);
  if (!urlParams.has('sd')) {
    window.location.href = "https://www.hakusan-porcelain.com/pages/brand";
  }
}
